
import PaymentTokenQuery from 'Query/PaymentToken.query';
import { showNotification } from 'Store/Notification/Notification.action';
import { getCardList } from 'Store/MyAccount/Card.action';
import { fetchQuery } from 'Util/Request';

export class CardDispatcher {
    requestCards(dispatch) {
        const query = PaymentTokenQuery.getPaymentTokensQuery();

        dispatch(getCardList([], true));

        return fetchQuery(query).then(
            ({ customerPaymentTokens: cards }) => {
                dispatch(getCardList(cards, false));
            },
            (error) => {
                dispatch(showNotification('error', error[0].message));
                dispatch(getCardList([], false));
            }
        );
    }
}

export default new CardDispatcher();
